export default {
  privacy: {
    lastUpdated: '最后更新时间：2022年3月18日',
    companyName: 'Linktivity Inc.',
    title: '隐私政策',
    personalInfoProtectionPolicy: '个人信息保护政策',
    personalInfoProtectionDescription:
      'Linktivity Inc.(以下称"公司")通过预订网站LINKTIVITY等收集用户的个人信息。公司认为保护用户个人信息以使用户能够安心便利地进行预订是极其重要的，公司遵守以下规定进行个人信息处理。',
    customerDataManager: '用户数据管理员',
    companyAddress: '日本东京都千代田区内幸町2-1-6 日比谷公园前19楼',
    acquisition: '采集',
    acquisitionDescription:
      '公司仅在法律要求时获得用户同意后，为达到规定的使用目的而采集最少必要的个人信息。',
    usage: '使用',
    usageDescription: '公司仅将从用户处采集的个人信息用于达到规定的使用目的。',
    storage: '存储和保留',
    storageDescription:
      '公司谨慎关注系统安全，防止从用户处采集的个人信息向外部泄露，进行个人信息的存储和保留。',
    destruction: '销毁和删除',
    destructionDescription:
      '公司对不再需要使用的个人数据从不再需要的时点起毫不迟延地进行销毁。',
    customerInquiry: '对用户查询的响应',
    customerInquiryDescription:
      '公司根据相关法律法规对用户关于持有个人数据的使用目的通知请求、公开请求、更正/增加/删除请求、使用中止/删除请求以及第三方提供中止请求进行对应。',
    safetyMeasures: '安全管理措施',
    safetyMeasuresDescription:
      '公司通过教育确保所有与LINKTIVITY服务相关的员工理解个人信息的重要性，并采取必要且适当的措施进行个人信息保护。',
    tableOfContents: '目录',
    policy1: {
      title: '公司采集的个人信息及使用目的',
      description:
        '公司为以下规定的使用目的采集和使用用户的地址、姓名、出生日期、联系方式、电子邮件地址、护照号码等个人信息。公司不在未获用户同意的情况下采集敏感个人信息。在采集用户个人信息时，如个人信息的使用目的未公开，公司应向用户通知或公开该采集的个人信息的使用目的。公司不在未获父母同意的情况下采集13岁以下儿童的个人信息。在提供13岁以下儿童的个人信息时，公司将其视为已获得父母同意，但如明确得知未获同意，公司除了与父母联系及相关目的外，不使用该个人信息。',
      serviceUsage: {
        title: 'LINKTIVITY服务使用(会员注册等)',
        description: '为使用LINKTIVITY服务，用户个人信息在公司内部共享。',
        legalBasis: '为提供用户要求的服务和功能而必需。'
      },
      ticketPurchase: {
        title: '车票购买申请',
        infoItems:
          '公司在处理来自产品提供商的车票购买申请时，采集用户的姓名、支付信息、护照号码以及用户的健康状况相关信息，包括健康状态和病史。',
        purpose:
          '公司采集和使用用户个人信息以验证来自产品提供商的车票购买资格并处理车票及相关费用的支付。为实现这一目的，公司可向产品提供商、运输公司、支付处理器和其他服务提供商(包括海外提供商)提供用户个人信息。',
        legalBasis: '为提供用户要求的服务和功能而必需。'
      },
      newsletter: {
        title: '发送新闻通讯(电子邮件杂志等)及用户通信',
        legalBasis: '基于用户同意采集。'
      },
      advertising: {
        title: '通过社交媒体和广告分发平台进行的广告',
        legalBasis: '基于用户同意采集。'
      },
      survey: {
        title: '问卷调查参与请求',
        legalBasis: '基于用户同意采集，用于改进预订网站、产品和服务。'
      },
      analysis: {
        title: '用户信息分析和管理',
        legalBasis:
          '为通过改进预订网站、产品和服务来追求和保护用户的正当利益而必需。'
      },
      fraudDetection: {
        title: '信用卡等欺诈使用检测',
        legalBasis: '为确保用户信用卡的安全并追求用户的正当利益而必需。'
      }
    },
    policy2: {
      title: '个人数据的第三方提供',
      description: '除以下情况外，公司不向第三方提供从用户处采集的个人数据。',
      case1:
        '当用户通过本隐私政策或其他方式事先同意向第三方(包括产品提供商、海外旅行社、社交媒体提供商、广告分发服务公司等)提供个人数据时。',
      case2: '当在达到规定使用目的所必需的范围内将个人数据处理外包给第三方时。',
      case3: '当法律要求提供时。',
      case4: '当为保护人类生命、身体或财产而必需，且难以获得用户同意时。',
      case5:
        '当为改进公共卫生或促进儿童健全发展而特别必需，且难以获得用户同意时。',
      case6:
        '当政府或地方政府为实施法律规定的事务而需要合作，且获得用户同意可能会阻碍该事务的执行时。'
    },

    policy3: {
      title: '个人数据处理的委托',
      description:
        '当公司在达到规定使用目的所必需的范围内将用户个人数据处理委托给第三方时，公司对受委托的机构进行必要且适当的监督。如受委托的机构进一步委托给其他机构，公司直接或间接监督受委托的机构是否对再委托机构进行了必要且适当的监督。再委托机构的进一步委托情况也应如此。'
    },
    policy4: {
      title: 'Cookie信息等采集',
      cookie: {
        title: 'Cookie',
        description1:
          'Cookie是存储在用户硬盘上包含有关用户信息的数据文件。公司不使用Cookie来识别个人。Cookie是会话Cookie，当用户关闭浏览器时不会被保留。Cookie用于改进用户服务、自定义网站、测量广告效果等目的。',
        description2:
          '公司将Cookie作为统计数据进行分析，以识别用户的兴趣和关注点并加以利用。Cookie也用于防止未授权访问。',
        description3:
          '用户可根据偏好禁用Cookie，但这样做会导致用户无法在LINKTIVITY进行预订。'
      },
      logFile: {
        title: '日志文件',
        description1:
          '公司自动采集某些信息并将其保存到日志文件。这些特定信息包括IP(互联网协议)地址、浏览器类型、ISP(互联网服务提供商)名称、参考/退出页面、操作系统及日期/时间戳。公司利用这些信息监控未授权访问、进行用户趋势分析、网站管理以及用户在网站上的行为追踪。',
        description2:
          '但是，公司以不能识别特定个人的方式使用这些信息，不会将采集的信息用于上述目的以外的任何目的。'
      },
      webBeacon: {
        title: '网络信标',
        description:
          '公司使用网络信标用于访问分析和附属计划。公司不使用网络信标进行上述目的以外的任何目的或用于识别特定个人。'
      },
      statisticalAnalysis: {
        title: '统计分析',
        description1:
          '公司使用第三方访问分析工具来识别哪些网站和服务受欢迎，并记录用户在LINKTIVITY网站内访问的页面和页面历史。',
        description2:
          '公司使用这些数据为在特定领域表示出兴趣的用户在LINKTIVITY内提供符合其兴趣的内容和广告。',
        description3:
          '公司也可采集不识别个人的统计信息。此外，公司采集的Cookie信息和其他方采集的Cookie信息也可在第三方访问分析工具平台上由双方查看。'
      }
    },
    policy5: {
      title: '匿名处理信息的处理',
      creation: {
        title: '匿名处理信息的创建',
        description1:
          '公司在创建匿名处理信息时采取以下措施。匿名处理信息是指根据法律要求以无法识别特定个人的方式处理个人信息而获得的个人相关信息，使得原个人信息无法恢复。',
        description2:
          '① 按照法律规定的标准进行适当处理 ② 按照法律规定的标准实施安全管理措施以防止删除的信息和处理方法相关信息的泄露 ③ 公开包含在创建的匿名处理信息中的个人相关信息的项目 ④ 不进行识别用于创建匿名处理信息的个人信息所涉原人的行为'
      },
      provision: {
        title: '匿名处理信息的提供',
        description:
          '当向第三方提供匿名处理信息时，公司公开包含在匿名处理信息中的个人相关信息的项目和提供方式，并向接收者明示所提供的信息是匿名处理信息。'
      },
      disclosure: {
        title: '关于匿名处理信息的公开',
        creationSubtitle: '匿名处理信息的创建',
        creationDescription:
          '关于公司持有的以下用户个人信息，公司在采取适当措施防止识别特定个人且确保原个人信息无法恢复的基础上，持续创建匿名处理信息。',
        itemsTitle: '包含在匿名处理信息中的个人相关信息的项目',
        itemsDescription:
          '平台服务提供相关采集的信息：购买日期、参与日期、凭证语言、销售金额范围、参与者数量、预订状态(已确认或已取消)、供应商位置和地区信息、旅行社位置国家。',
        thirdPartyTitle: '匿名处理信息的第三方提供',
        thirdPartyDescription:
          '关于公司创建或持有的匿名处理信息，公司在明示该信息是匿名处理信息的基础上持续向第三方提供。',
        provisionMethod:
          '通过电子通信手段(电子邮件、服务器上传、API集成等)或物理媒体(如DVD)传送密码保护的电子文件。'
      }
    },
    policy6: {
      title: '个人数据的安全管理措施',
      description1:
        '公司采取组织、技术和物理安全管理措施以防止个人数据的泄露、盗用、滥用、未授权访问、篡改和破坏。公司存储个人数据的服务器访问仅限于拥有ID和密码访问权限的授权员工，其中某些个人数据的访问权限仅授予数据管理所必需的最少员工。',
      description2:
        '此外，包含信用卡信息的个人数据存储在分散于多个数据中心的安全环境中。公司对与预订交易相关的所有页面使用安全套接层(SSL)加密。使用SSL兼容浏览器可维护通过互联网传输的个人数据和信用卡信息的机密性。',
      description3:
        '处理用户个人数据的公司员工在离开终端时使用密码保护的屏幕保护程序。',
      description4:
        '此外，公司对某些部门每月进行一次、公司范围内每年至少进行两次关于个人信息重要性等的教育培训。公司还保留这些培训的记录。'
    },
    policy7: {
      title: '关于个人数据处理的用户权利',
      description:
        '根据2016年4月27日的欧盟通用数据保护条例(GDPR) 2016/679，用户在个人数据处理方面具有以下权利：',
      right1: '访问权',
      right2: '更正权',
      right3: '删除权(被遗忘权)和限制处理权',
      right4: '数据可携性权',
      right5: '异议权',
      right6: '不受基于分析的自动化决策约束的权利。'
    },
    policy8: {
      title: '关于公开、更正、中止使用等请求',
      description1:
        '公司通过下文第11节所述的联系方式对用户关于持有个人数据的使用目的通知请求、公开请求、更正/增加/删除请求、使用中止/删除请求以及第三方提供中止请求(以下统称"公开等请求")进行对应。',
      description2:
        '此外，公司通过用户的账户页面对用户更改和确认会员信息以及中止电子邮件杂志配送等的请求进行对应。'
    },
    policy9: {
      title: '关于外部链接',
      description:
        'LINKTIVITY主页包含指向其他网站的链接。本隐私政策仅适用于通过LINKTIVITY主页采集的信息，公司对其他网站的隐私政策或内容不承担责任。用户应阅读所链接网站的隐私政策并确认其个人信息如何被处理。'
    },
    policy10: {
      title: '隐私政策的更改',
      description:
        '公司在LINKTIVITY主页上发布本隐私政策，使用户能够始终了解公司采集什么个人信息、出于什么目的采集以及如何使用。隐私政策的任何更改也会在LINKTIVITY主页上发布并向用户公开。'
    },
    policy11: {
      title: '联系方式',
      description1:
        '关于公司隐私政策、公司个人信息保护措施、采集和使用用户个人信息或提出公开等请求的任何问题，请使用下面的联系表。代表将在5个工作日内回复。',
      company: 'Linktivity Inc.',
      address: '日本东京都千代田区内幸町2-1-6 日比谷公园前19楼',
      dpoContact: '数据保护官联系方式: dpo@linktivity.co.jp'
    },
    contentLabels: {
      acquisitionOfPersonalInfo: '采集的个人信息',
      specificPurpose: '具体的使用目的',
      legalBasis: '法律依据：',
      provisionMethod: '提供方式'
    }
  }
};
